import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { ArrowUpRightIcon, LockIcon } from "lucide-react";
import { useBooking } from "../contexts/BookingContext";
import { TitleUnderline } from "../components/TitleUnderline";
import { ctas } from "../data/content";
import { groupBenefits, groupImage, groupName } from "../data/facebookGroup";
export function FacebookGroup() {
  const {
    openBooking
  } = useBooking();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <>
      <section className="w-full bg-cream lg:h-[calc(100svh-4rem)] lg:min-h-[600px]" data-id="element-291" data-mp="296bk7qtac291">
        {/* Mobile: title → photo → text. Tablet: text → photo. Desktop: text left, photo right. */}
        <div className="mx-auto grid h-full max-w-7xl px-5 py-6 md:px-10 lg:grid-cols-12 lg:grid-rows-[1fr_auto_auto_1fr] lg:gap-x-10 lg:py-[2.5vh]" data-id="element-292" data-mp="2j5u1u0lq3bxx">
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="order-1 lg:col-span-6 lg:col-start-1 lg:row-start-2" data-id="element-293" data-mp="3pl38brjeencj">
            <p className="text-sm tracking-wide text-bark" data-id="element-294" data-mp="350l2vupck4ac">Kostenlose Facebook-Gruppe · {groupName}</p>
            <h1 className="mt-5 font-serif text-5xl font-medium leading-[1.04] text-espresso sm:text-6xl lg:text-[clamp(3rem,8vh,4.75rem)]" data-id="element-295" data-mp="30wlobhnmnfjm">
              Lerne meine <TitleUnderline data-id="element-296" data-mp="2qzqs55ettr8i"><em className="font-normal" data-id="element-297" data-mp="2r0a9ol0kedm0">FlowKus</em></TitleUnderline>-Methode kennen
            </h1>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: 0.03
        }} className="order-3 md:order-2 lg:col-span-6 lg:col-start-1 lg:row-start-3" data-id="element-298" data-mp="2m7z8leu38lrv">
            <p className="mt-6 max-w-xl text-lg font-light leading-relaxed text-cocoa" data-id="element-299" data-mp="289iw179jo11t">
              … und erfahre, wie Du das Buch Deines Lebens schreibst. In meiner Gruppe teile ich jede Woche
              Wissen, Erfahrungen und Impulse, mit Menschen, die denselben Traum haben wie Du.
            </p>
            <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-5" data-id="element-300" data-mp="1ymoj4ws1brao">
              <a href={ctas.facebook.href} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-bark px-8 py-4 text-sm uppercase tracking-[0.18em] text-cream transition-colors duration-150 hover:bg-bark-deep" data-id="element-301" data-mp="1jpfre1ytklif">
                Jetzt kostenlos beitreten
                <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-302" data-mp="22mpbllbyy30q" />
              </a>
              <span className="inline-flex items-center gap-2 text-sm text-taupe" data-id="element-303" data-mp="2vbe2krjb8ryr">
                <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-304" data-mp="302clzzzli668" />
                Deine Daten sind bei uns sicher.
              </span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.98
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: 0.05
        }} className="order-2 mt-6 h-[34svh] min-h-[240px] max-h-[560px] md:order-3 md:mt-10 md:h-[50svh] lg:col-span-6 lg:col-start-7 lg:row-span-4 lg:row-start-1 lg:mt-0 lg:h-full lg:max-h-none" data-id="element-305" data-mp="olkhxjsazh6e">
            <div className="h-full w-full overflow-hidden rounded-t-[12rem] rounded-b-[1.5rem] bg-cream-deep" data-id="element-306" data-mp="poj81z8u83k">
              <img src={groupImage} alt="Eva-Maria Bast im Gespräch mit zwei Frauen auf einem Boot" className="h-full w-full object-cover object-[45%_center]" data-id="element-307" data-mp="ep7s4wzvpngx" />
            </div>
          </motion.div>
        </div>
      </section>

      <section aria-labelledby="benefits-title" className="flex w-full items-center bg-cream-deep lg:min-h-[calc(100svh-4rem)]" data-id="element-308" data-mp="1m31deirai73f">
        <div className="mx-auto grid w-full max-w-7xl gap-12 px-5 py-10 md:px-10 lg:grid-cols-12 lg:py-[3vh]" data-id="element-309" data-mp="2heizanmgfawy">
          <div className="lg:col-span-5" data-id="element-310" data-mp="2lf2zy168kwnu">
            <div className="lg:sticky lg:top-28" data-id="element-311" data-mp="2qe5sim515aex">
              <h2 id="benefits-title" className="font-serif text-4xl font-medium leading-tight text-espresso sm:text-5xl" data-id="element-312" data-mp="2qcb9xeh8due0">
                Das erwartet Dich in der <TitleUnderline data-id="element-313" data-mp="30cbx5bi80unh">Gruppe</TitleUnderline>
              </h2>
              <p className="mt-5 max-w-md text-lg font-light leading-relaxed text-cocoa" data-id="element-314" data-mp="30a95kn1f6tgn">
                Kein loser Austausch, sondern echte Begleitung: Woche für Woche ein Stück näher an Dein fertiges Buch.
              </p>
              <a href={ctas.facebook.href} target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center justify-center whitespace-nowrap rounded-full border border-bark px-8 py-4 text-sm uppercase tracking-[0.18em] text-bark transition-colors duration-150 hover:bg-bark hover:text-cream" data-id="element-315" data-mp="3e404z2lfswyn">
                Jetzt kostenlos beitreten
              </a>
            </div>
          </div>

          <ul className="border-t border-cream-line lg:col-span-6 lg:col-start-7" data-id="element-316" data-mp="12g53lgkh7yxz">
            {groupBenefits.map(benefit => <li key={benefit.title} className="border-b border-cream-line py-5 lg:py-[2.6vh]" data-id="element-317" data-mp="xhtu56y3fqga">
                <h3 className="font-serif text-2xl font-medium text-espresso lg:text-[1.75rem]" data-id="element-318" data-mp="1v528mhzofz8s">{benefit.title}</h3>
                <p className="mt-1.5 max-w-lg font-light leading-relaxed text-cocoa" data-id="element-319" data-mp="1q70pxy65y1xu">{benefit.text}</p>
              </li>)}
          </ul>
        </div>
      </section>

      <section aria-labelledby="group-about-title" className="flex w-full items-center bg-cream text-espresso lg:min-h-[calc(100svh-4rem)]" data-id="element-320" data-mp="1ggo8ietnaovx">
        <div className="mx-auto grid w-full max-w-7xl gap-12 px-5 py-10 md:px-10 lg:grid-cols-12 lg:py-[3vh]" data-id="element-321" data-mp="2dx4pnug8dhjk">
          <div className="lg:col-span-5" data-id="element-322" data-mp="779tuwjv3ezc">
            <h2 id="group-about-title" className="font-serif text-4xl font-medium leading-tight sm:text-5xl" data-id="element-323" data-mp="78ci0wpsv3bk">
              Über mich
            </h2>
            <p className="mt-5 text-sm tracking-wide text-bark" data-id="element-324" data-mp="3tmm614pti9bt">
              Achtfache SPIEGEL-Bestseller-Autorin · Verlegerin · mehrfach preisgekrönte Journalistin
            </p>
          </div>
          <div className="lg:col-span-6 lg:col-start-7" data-id="element-325" data-mp="3klxseb4c6azg">
            <p className="text-lg font-light leading-relaxed text-cocoa" data-id="element-326" data-mp="3kkcymnpuiw2n">
              Nach über 20 Jahren in der Verlagsbranche wurde in mir der Wunsch immer stärker, mein Wissen
              weiterzugeben und andere Menschen auf dem Weg zu ihrem Buch zu unterstützen. Dafür habe ich die
              FlowKus-Methode entwickelt, die Fokus und Flow kombiniert.
            </p>
            <p className="mt-6 font-serif text-3xl leading-snug text-espresso" data-id="element-327" data-mp="18xeyqkh88o6c">
              So entsteht eine tiefe Verbundenheit mit Deiner inneren Schriftstellerin, Deinem inneren Schriftsteller,
              und die Geschichte sprudelt regelrecht aus Dir heraus.
            </p>
            <p className="mt-6 text-lg font-light leading-relaxed text-cocoa" data-id="element-328" data-mp="2tf7aqleiuflc">
              Meine Coachees schreiben nicht nur magnetische Texte, ein riesiges Potpourri an Handwerkszeug rundet
              alles ab.
            </p>
            <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" data-id="element-329" data-mp="33b0yz21lrxiy">
              <a href={ctas.facebook.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center whitespace-nowrap rounded-full border border-bark bg-bark px-8 py-4 text-sm uppercase tracking-[0.18em] text-cream transition-colors duration-150 hover:border-bark-deep hover:bg-bark-deep" data-id="element-330" data-mp="3h2ffn281fmmu">
                Jetzt kostenlos beitreten
              </a>
              <button type="button" onClick={openBooking} className="inline-flex items-center justify-center whitespace-nowrap rounded-full border border-bark px-8 py-4 text-sm uppercase tracking-[0.18em] text-bark transition-colors duration-150 hover:bg-bark hover:text-cream" data-id="element-331" data-mp="1rplokgemrytf">
                {ctas.call.label}
              </button>
            </div>
          </div>
        </div>
      </section>
    </>;
}